module.exports = __webpack_public_path__ + "media/images/black_history_month/calender-d3120e2db6165a74fd3ecc306a7be699.svg";